// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Pilih',
    titleLinkTooltip: 'Pergi ke halaman',
    collapseCardTooltip: 'Tutup kartu',
    expandCardTooltip: 'Perluas kartu'
  },
  CardList: {
    loadMore: 'Muat lebih banyak',
    notFound: 'Tidak ada item yang ditemukan.',
    toolbarSelect: 'Pilih',
    viewCards: 'Kartu',
    viewTiles: 'Ubin',
    viewList: 'Daftar',
    toolbarView: 'Lihat'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Keluar',
    cancel: 'Kembali',
    content: 'Apakah Anda yakin mau menutup dan meninggalkan jendela ini? Semua perubahan data yang Anda lakukan tidak akan disimpan.'
  },
  Cuttable: {
    showMore: 'Tampilkan lebih banyak',
    showLess: 'Tampilkan lebih sedikit'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Batalkan'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Batalkan'
  },
  Dropdown: {
    close: 'Tutup'
  },
  Form: {
    submitButton: 'Simpan',
    applyButton: 'Terapkan',
    cancelButton: 'Batalkan'
  },
  FormField: {
    clear: 'Bersihkan',
    remove: 'Hapus',
    addMore: 'Tambahkan satu lagi',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'Untuk memperkuat kata sandi Anda:',
    passwordTooShort: 'Buat kata sandi lebih panjang.',
    lettersLowerCase: 'Gunakan sedikitnya satu huruf kecil.',
    lettersUpperCase: 'Gunakan sedikitnya satu huruf besar.',
    numbers1: 'Gunakan sedikitnya satu angka.',
    numbers3: 'Gunakan sedikitnya tiga angka.',
    specialChar1: 'Gunakan sedikitnya satu karakter khusus (sebagai contoh: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Gunakan sedikitnya dua karakter khusus (sebagai contoh: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Gunakan huruf besar dan huruf kecil.',
    comboLettersAndNumbers: 'Gunakan angka dan karakter.',
    comboLettersNumbersSpecial: 'Gunakan angka, karakter, dan karakter khusus.',
    yourPasswordIsStrong: 'Anda dapat membuatnya lebih kuat dengan memperpanjangnya.',
    passwordStrength: 'Kekuatan kata sandi adalah %%strength%%.',
    strengthVeryStrong: 'SANGAT KUAT',
    strengthStrong: 'KUAT',
    strengthVeryWeak: 'SANGAT LEMAH',
    strengthWeak: 'LEMAH',
    strengthMedium: 'SEDANG',
    hidePassword: 'Sembunyikan kata sandi',
    showPassword: 'Tunjukkan kata sandi',
    generateButton: 'Hasilkan',
    copyButtonHint: 'Salin kata sandi',
    copySuccessToast: 'Kata sandi sudah disalin',
    generateButtonHint: 'Hasilkan kata sandi kuat'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Buang perubahan',
    editButtonHint: 'Edit nilai',
    okButtonHint: 'Simpan perubahan'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Pilih file...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '%%totalRows%% total item',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%% dari %%totalRows%% item dipilih',
    all: 'Semua',
    allItemsOnPageSelected: 'Semua item di halaman dipilih',
    allItemsSelected: 'Semua item dipilih',
    selectAllItems: 'Pilih semua item',
    selectAllItemsOnPage: 'Pilih semua item di halaman',
    deselectAll: 'Batalkan pilihan',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Tidak dapat menemukan item yang sesuai dengan filter',
    emptyTitle: 'Sepertinya tidak ada apa pun di sini',
    filteredDescription: 'Perbaiki kueri Anda atau hapus beberapa kriteria dari filter dan coba lagi.'
  },
  ListOperation: {
    cancelButton: 'Batalkan'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'dari %%total%%',
    itemsPerPage: 'Item per halaman',
    all: 'Semua',
    total: 'Halaman %%current%% dari %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Tutup',
    cancelButton: 'Batalkan'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Tidak ada pilihan',
    placeholder: 'Pilih...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% dari %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Tutup grup'
  },
  Toast: {
    closeButton: 'Close'
  }
};